// extracted by mini-css-extract-plugin
module.exports = {"tripleProduct":"TripleProduct_tripleProduct__43Kvw","images":"TripleProduct_images__O2k7s"};